

import React, { useState } from 'react';
import './../style.scss';
import { FormattedMessage } from 'react-intl';
import { InputText } from 'components';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobileAlt } from '@fortawesome/fontawesome-free-solid';

const regexPhoneNumber = /^\+?(?:[0-9]??).{9,12}[0-9]/;

const ForgotPassword = ({ phoneNumber, handlePhoneNumber, sendOTP, intl }) => {
  const [errorMsg, setErrorMsg] = useState('');

  const validPhoneNumber = (value) => {
    const test = regexPhoneNumber.test(value);
    if (!test || value.length > 11) {
      setErrorMsg(intl.formatMessage({ id: 'IDS_ERROR_ISDN_LONG' }));
      return false;
    } else {
      setErrorMsg('');
      return true;
    }
  }

  const handlePhone = (value) => {
    handlePhoneNumber(value);
    validPhoneNumber(value);
  }

  const handleSendOtp = (value) => {
    if (validPhoneNumber(phoneNumber)) {
      sendOTP(value);
    } else {
      setErrorMsg(intl.formatMessage({ id: 'IDS_ERROR_ISDN_LONG' }));
    }
  }
  
  return (
    <div className="login__confirm position-relative">
      <FontAwesomeIcon
        color="#007bff"
        icon={faMobileAlt}
        size="lg"
        className="login__icon-mobile"
      />
      <InputText
        value={phoneNumber}
        handleOnChange={handlePhone}
        errorMsg={errorMsg}
        placeholder={intl.formatMessage({ id: 'IDS_TV_REQUEST_PHONE_NUMBER' })}
      />
      <Button className="login__btn mt-5" onClick={() => handleSendOtp(true)}>
        <FormattedMessage id='IDS_TV_LOGINNEW_GUIOTP' />
      </Button>
    </div>
  );
}

export default React.memo(ForgotPassword);

